import { createSlice } from '@reduxjs/toolkit';
import 'primereact/button';
import 'primereact/splitbutton';
import 'primereact/dataview';
import 'primereact/rating';
import 'primereact/tabview';
import 'primereact/card';
import 'primereact/selectbutton';
import 'primereact/datatable';
import 'primereact/column';
import 'primereact/inputtext';
import 'primereact/tag';
import 'primereact/calendar';
import 'primereact/image';
import 'primereact/checkbox';
import 'primereact/dropdown';
import 'primereact/sidebar';
import 'primereact/dialog';
import 'primereact/inputswitch';
import 'primereact/radiobutton';
import 'primereact/inputnumber';
import 'primereact/slider';
import 'primereact/accordion';
import 'primereact/chart';
import 'primereact/panel';
import 'primereact/badge';
import 'primereact/skeleton';
import 'primereact/togglebutton';
import toast from '../../modules/primereact/customComponents/toast.js';
import 'primereact/splitter';

const initialState = {};
const globalComponentSlice = createSlice({
    name: 'globalComponent',
    initialState,
    reducers: {
        showToast: (state, { payload }) => {
            var _a;
            const { severity, summary, detail } = payload;
            (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity, summary, detail });
        },
    },
});
// Action creators are generated for each case reducer function
globalComponentSlice.actions;
var globalComponentReducer = globalComponentSlice.reducer;

export { globalComponentReducer as default, globalComponentSlice };
//# sourceMappingURL=globalComponentSlice.js.map
